"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _API = require("./API");
Object.keys(_API).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _API[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _API[key];
    }
  });
});
var _API2 = require("./API.types");
Object.keys(_API2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _API2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _API2[key];
    }
  });
});
var _AccessKeys = require("./AccessKeys");
Object.keys(_AccessKeys).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AccessKeys[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AccessKeys[key];
    }
  });
});
var _Apps = require("./Apps");
Object.keys(_Apps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Apps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Apps[key];
    }
  });
});
var _Assistants = require("./Assistants");
Object.keys(_Assistants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Assistants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Assistants[key];
    }
  });
});
var _Banks = require("./Banks");
Object.keys(_Banks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Banks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Banks[key];
    }
  });
});
var _Companies = require("./Companies");
Object.keys(_Companies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Companies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Companies[key];
    }
  });
});
var _Configurations = require("./Configurations");
Object.keys(_Configurations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Configurations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Configurations[key];
    }
  });
});
var _Connectors = require("./Connectors");
Object.keys(_Connectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Connectors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Connectors[key];
    }
  });
});
var _Countries = require("./Countries");
Object.keys(_Countries).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Countries[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Countries[key];
    }
  });
});
var _Files = require("./Files");
Object.keys(_Files).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Files[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Files[key];
    }
  });
});
var _Me = require("./Me");
Object.keys(_Me).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Me[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Me[key];
    }
  });
});
var _Roles = require("./Roles");
Object.keys(_Roles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Roles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Roles[key];
    }
  });
});
var _Teams = require("./Teams");
Object.keys(_Teams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Teams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Teams[key];
    }
  });
});
var _Tenants = require("./Tenants");
Object.keys(_Tenants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Tenants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Tenants[key];
    }
  });
});
var _TenantConfigurations = require("./TenantConfigurations");
Object.keys(_TenantConfigurations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TenantConfigurations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TenantConfigurations[key];
    }
  });
});
var _Users = require("./Users");
Object.keys(_Users).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Users[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Users[key];
    }
  });
});
var _Catalogs = require("./Catalogs");
Object.keys(_Catalogs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Catalogs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Catalogs[key];
    }
  });
});
var _Families = require("./Families");
Object.keys(_Families).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Families[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Families[key];
    }
  });
});
var _ExtendedFields = require("./ExtendedFields");
Object.keys(_ExtendedFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ExtendedFields[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ExtendedFields[key];
    }
  });
});
var _Templates = require("./Templates");
Object.keys(_Templates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Templates[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Templates[key];
    }
  });
});
var _Workflows = require("./Workflows");
Object.keys(_Workflows).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Workflows[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Workflows[key];
    }
  });
});
var _Advances = require("./Advances");
Object.keys(_Advances).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Advances[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Advances[key];
    }
  });
});
var _AppliedPolicies = require("./AppliedPolicies");
Object.keys(_AppliedPolicies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppliedPolicies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AppliedPolicies[key];
    }
  });
});
var _AuthorizingGroups = require("./AuthorizingGroups");
Object.keys(_AuthorizingGroups).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuthorizingGroups[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AuthorizingGroups[key];
    }
  });
});
var _Collaborators = require("./Collaborators");
Object.keys(_Collaborators).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Collaborators[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Collaborators[key];
    }
  });
});
var _Currencies = require("./Currencies");
Object.keys(_Currencies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Currencies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Currencies[key];
    }
  });
});
var _DeductibleRules = require("./DeductibleRules");
Object.keys(_DeductibleRules).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeductibleRules[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DeductibleRules[key];
    }
  });
});
var _Deductibles = require("./Deductibles");
Object.keys(_Deductibles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Deductibles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Deductibles[key];
    }
  });
});
var _Expenses = require("./Expenses");
Object.keys(_Expenses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Expenses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Expenses[key];
    }
  });
});
var _ExpensePolicies = require("./ExpensePolicies");
Object.keys(_ExpensePolicies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ExpensePolicies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ExpensePolicies[key];
    }
  });
});
var _ExpenseTemplates = require("./ExpenseTemplates");
Object.keys(_ExpenseTemplates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ExpenseTemplates[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ExpenseTemplates[key];
    }
  });
});
var _ExpenseTypes = require("./ExpenseTypes");
Object.keys(_ExpenseTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ExpenseTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ExpenseTypes[key];
    }
  });
});
var _Inbounds = require("./Inbounds");
Object.keys(_Inbounds).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Inbounds[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Inbounds[key];
    }
  });
});
var _JournalEntries = require("./JournalEntries");
Object.keys(_JournalEntries).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _JournalEntries[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _JournalEntries[key];
    }
  });
});
var _LedgerAccounts = require("./LedgerAccounts");
Object.keys(_LedgerAccounts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LedgerAccounts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LedgerAccounts[key];
    }
  });
});
var _PayableDocuments = require("./PayableDocuments");
Object.keys(_PayableDocuments).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PayableDocuments[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PayableDocuments[key];
    }
  });
});
var _PaymentConfigurations = require("./PaymentConfigurations");
Object.keys(_PaymentConfigurations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaymentConfigurations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PaymentConfigurations[key];
    }
  });
});
var _Reconciliations = require("./Reconciliations");
Object.keys(_Reconciliations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Reconciliations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Reconciliations[key];
    }
  });
});
var _ReconciliationAllowances = require("./ReconciliationAllowances");
Object.keys(_ReconciliationAllowances).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReconciliationAllowances[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReconciliationAllowances[key];
    }
  });
});
var _ReconciliationConfigurations = require("./ReconciliationConfigurations");
Object.keys(_ReconciliationConfigurations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReconciliationConfigurations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReconciliationConfigurations[key];
    }
  });
});
var _ReconciliationFiles = require("./ReconciliationFiles");
Object.keys(_ReconciliationFiles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReconciliationFiles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReconciliationFiles[key];
    }
  });
});
var _ReconciliationRefunds = require("./ReconciliationRefunds");
Object.keys(_ReconciliationRefunds).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReconciliationRefunds[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReconciliationRefunds[key];
    }
  });
});
var _ReconciliationRefundTasks = require("./ReconciliationRefundTasks");
Object.keys(_ReconciliationRefundTasks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReconciliationRefundTasks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReconciliationRefundTasks[key];
    }
  });
});
var _Refunds = require("./Refunds");
Object.keys(_Refunds).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Refunds[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Refunds[key];
    }
  });
});
var _ResetCdg = require("./ResetCdg");
Object.keys(_ResetCdg).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ResetCdg[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ResetCdg[key];
    }
  });
});
var _TaxClassifications = require("./TaxClassifications");
Object.keys(_TaxClassifications).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TaxClassifications[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TaxClassifications[key];
    }
  });
});
var _UserHierarchies = require("./UserHierarchies");
Object.keys(_UserHierarchies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserHierarchies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UserHierarchies[key];
    }
  });
});
var _UserCompanies = require("./UserCompanies");
Object.keys(_UserCompanies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserCompanies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UserCompanies[key];
    }
  });
});
var _UserPaymentMethods = require("./UserPaymentMethods");
Object.keys(_UserPaymentMethods).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserPaymentMethods[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UserPaymentMethods[key];
    }
  });
});
var _Workplaces = require("./Workplaces");
Object.keys(_Workplaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Workplaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Workplaces[key];
    }
  });
});
var _Cfdis = require("./Cfdis");
Object.keys(_Cfdis).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Cfdis[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Cfdis[key];
    }
  });
});
var _Rules = require("./Rules");
Object.keys(_Rules).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Rules[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Rules[key];
    }
  });
});
var _Designs = require("./Designs");
Object.keys(_Designs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Designs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Designs[key];
    }
  });
});
var _DesignTemplates = require("./DesignTemplates");
Object.keys(_DesignTemplates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DesignTemplates[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DesignTemplates[key];
    }
  });
});
var _Messages = require("./Messages");
Object.keys(_Messages).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Messages[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Messages[key];
    }
  });
});
var _Notifications = require("./Notifications");
Object.keys(_Notifications).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Notifications[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Notifications[key];
    }
  });
});
var _Topics = require("./Topics");
Object.keys(_Topics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Topics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Topics[key];
    }
  });
});
var _Balances = require("./Balances");
Object.keys(_Balances).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Balances[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Balances[key];
    }
  });
});
var _BalanceStatements = require("./BalanceStatements");
Object.keys(_BalanceStatements).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BalanceStatements[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BalanceStatements[key];
    }
  });
});
var _Cards = require("./Cards");
Object.keys(_Cards).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Cards[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Cards[key];
    }
  });
});
var _CardStatements = require("./CardStatements");
Object.keys(_CardStatements).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CardStatements[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CardStatements[key];
    }
  });
});
var _AllocationConfigurations = require("./AllocationConfigurations");
Object.keys(_AllocationConfigurations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AllocationConfigurations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AllocationConfigurations[key];
    }
  });
});
var _Allocations = require("./Allocations");
Object.keys(_Allocations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Allocations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Allocations[key];
    }
  });
});
var _CostCenters = require("./CostCenters");
Object.keys(_CostCenters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CostCenters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CostCenters[key];
    }
  });
});
var _BudgetCompanies = require("./BudgetCompanies");
Object.keys(_BudgetCompanies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BudgetCompanies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BudgetCompanies[key];
    }
  });
});
var _BudgetTemplates = require("./BudgetTemplates");
Object.keys(_BudgetTemplates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BudgetTemplates[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BudgetTemplates[key];
    }
  });
});
var _Budgets = require("./Budgets");
Object.keys(_Budgets).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Budgets[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Budgets[key];
    }
  });
});
var _BudgetLines = require("./BudgetLines");
Object.keys(_BudgetLines).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BudgetLines[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BudgetLines[key];
    }
  });
});
var _Providers = require("./Providers");
Object.keys(_Providers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Providers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Providers[key];
    }
  });
});
var _ErpConnections = require("./ErpConnections");
Object.keys(_ErpConnections).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErpConnections[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ErpConnections[key];
    }
  });
});
var _Requisitions = require("./Requisitions");
Object.keys(_Requisitions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Requisitions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Requisitions[key];
    }
  });
});
var _RequisitionTypes = require("./RequisitionTypes");
Object.keys(_RequisitionTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RequisitionTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RequisitionTypes[key];
    }
  });
});
var _AuxiliarCatalogs = require("./AuxiliarCatalogs");
Object.keys(_AuxiliarCatalogs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuxiliarCatalogs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AuxiliarCatalogs[key];
    }
  });
});
var _OnboardingUploads = require("./OnboardingUploads");
Object.keys(_OnboardingUploads).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OnboardingUploads[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _OnboardingUploads[key];
    }
  });
});
var _BuiltinPlugins = require("./BuiltinPlugins");
Object.keys(_BuiltinPlugins).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BuiltinPlugins[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BuiltinPlugins[key];
    }
  });
});
var _Plugins = require("./Plugins");
Object.keys(_Plugins).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Plugins[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Plugins[key];
    }
  });
});
var _Connections = require("./Connections");
Object.keys(_Connections).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Connections[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Connections[key];
    }
  });
});
var _Destinations = require("./Destinations");
Object.keys(_Destinations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Destinations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Destinations[key];
    }
  });
});
var _Triggers = require("./Triggers");
Object.keys(_Triggers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Triggers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Triggers[key];
    }
  });
});
var _i18n = require("./i18n");
Object.keys(_i18n).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _i18n[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _i18n[key];
    }
  });
});
var _MessageEntries = require("./MessageEntries");
Object.keys(_MessageEntries).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MessageEntries[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MessageEntries[key];
    }
  });
});
var _Health = require("./Health");
Object.keys(_Health).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Health[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Health[key];
    }
  });
});